import { requestWithToken } from '../../utilities/request';
import { HEAD_OFFICE_OPTION } from '../../components/PartnerCompanyBranchDropdown';

/**
 * 作業員一覧取得API
 * GET /api/private/companies/:company_id/workers/list
 * @param {number} companyId 会社id
 * @param {object} param
 */
const list = (companyId, param) => {
  let url = `/api/private/ccus/companies/${companyId}/workers/list`;
  if (param.partner_company_branch_id === HEAD_OFFICE_OPTION.id) {
    url += '?partner_company_branch_id=';
    param.partner_company_branch_id = null;
  }
  return requestWithToken({
    method: 'GET',
    url,
    params: param,
    isQuiet: param.isQuiet || false,
  });
};

/**
 * 作業員復旧API
 * @param data
 * @returns {Promise<*>}
 */
const active = data => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/workers/active',
    data,
  });
};

/**
 * 作業員停止API
 * @param data
 * @returns {Promise<*>}
 */
const inactive = data => {
  return requestWithToken({
    method: 'PATCH',
    url: '/api/private/workers/inactive',
    data,
  });
};

/**
 * 作業員データ取り込みチェックAPI
 * POST /api/private/ccus/companies/:company_id/workers/bulk_confirm
 * @param {number} companyId 会社id
 * @param {*} param 設定パラメータ
 */
const captureCheck = (companyId, param) => {
  return requestWithToken(
    {
      method: 'POST',
      url: `/api/private/ccus/companies/${companyId}/workers/bulk_confirm`,
      data: param,
    },
    false,
    false
  );
};

/**
 * 作業員データ一括登録API
 * POST /api/private/ccus/companies/:company_id/workers/bulk_update
 * @param {number} companyId 会社id
 * @param {*} param 設定パラメータ
 */
const batchRegister = (companyId, param) => {
  return requestWithToken(
    {
      method: 'POST',
      url: `/api/private/ccus/companies/${companyId}/workers/bulk_update`,
      data: param,
    },
    true,
    false
  );
};

/**
 * CCUS技能者情報複数取得API
 * POST /api/private/ccus/workers_sync
 * @param {object} param
 */
const requestConnectionCcus = param => {
  return requestWithToken({
    method: 'POST',
    url: `/api/private/ccus/workers_sync`,
    data: param,
  });
};

const getExportExcelFileInfo = (url, params) => {
  return requestWithToken({
    method: 'GET',
    url,
    params,
  });
};

const getExportExcelFile = url => {
  return requestWithToken({
    method: 'GET',
    url,
    responseType: 'blob',
  });
};

const getExpirationWorkers = id => {
  let url = `/api/private/ccus/companies/${id}/workers/expiration`;
  return requestWithToken({
    method: 'GET',
    url,
  });
};

const getRankConsitencyStatus = id => {
  let url = `/api/private/ccus/companies/${id}/workers/rank_consistency_status`;
  return requestWithToken({
    method: 'GET',
    url,
  });
};

const fetchWorkerImportBatch = params => {
  return requestWithToken(
    {
      method: 'GET',
      url: `/api/private/ccus/workers/fetch_worker_import_batch`,
      params,
    },
    false,
    false
  );
};

const getDialogDisplaySettings = params => {
  return requestWithToken({
    method: 'GET',
    url: `/api/private/dialog_display_settings`,
    params,
  });
};

const updateDialogDisplaySettings = params => {
  return requestWithToken({
    method: 'PATCH',
    url: `/api/private/dialog_display_settings`,
    params,
  });
};

export const WorkersApi = {
  list,
  active,
  inactive,
  captureCheck,
  batchRegister,
  requestConnectionCcus,
  getExportExcelFileInfo,
  getExportExcelFile,
  getExpirationWorkers,
  fetchWorkerImportBatch,
  getRankConsitencyStatus,
  getDialogDisplaySettings,
  updateDialogDisplaySettings,
};

export default WorkersApi;



// WEBPACK FOOTER //
// ./src/services/workers/WorkersApi.js